import styled from "@emotion/styled";
import {Flex} from "antd";

export const ContentWrapper = styled(Flex)`
  gap:12px;
  flex-direction: column;
  align-items: center;
`
